import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { LoginModalBaseComponent } from '@streamamg/cloud-pay-lib';
import { WpCommonData } from '../../types/wordpress/common-data.type';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginModalComponent extends LoginModalBaseComponent implements OnInit {
  @Input() wpCommonData: WpCommonData;
  public showPassword = false;


  constructor(
    protected cd: ChangeDetectorRef,
  ) {
    super(cd);
  }

  ngOnInit(): void {
    super.init();
  }
}
